<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-align-vertical-centers`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 42a1 1 0 01-1-1V26H5c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1h6V7a1 1 0 011-1h8a1 1 0 011 1v15h6v-8a1 1 0 011-1h8a1 1 0 011 1v8h6c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1h-6v8a1 1 0 01-1 1h-8a1 1 0 01-1-1v-8h-6v15a1 1 0 01-1 1h-8z"/></svg>
</template>
<script>

export default {
  name: 'IconAlignVerticalCenters',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
